const aaa = [
	{
		path: "staffshuju",
		component: () => import("@/views/shuju/staffshuju.vue"),
		meta:{title:'员工提成',keepAlive:true},
	},
	{
		path: "staffshujuDetail",
		component: () => import("@/views/shuju/staffshujuDetail.vue"),
		meta:{title:'员工提成'},
	},
	
]
export default aaa;